import React, { useState, useEffect } from "react";
import Sidebar from "./Sidebar";
import Header from "./Header";
import { useTheme } from "../../contexts/ThemeContext";

const Layout = ({ children }) => {
  const { colors } = useTheme();
  const [isSidebarCollapsed, setIsSidebarCollapsed] = useState(true);
  const [isMobileMenuOpen, setIsMobileMenuOpen] = useState(false);

  const toggleSidebar = () => {
    // On mobile, toggle mobile menu
    // On desktop, toggle collapse
    if (window.innerWidth < 1024) {
      setIsMobileMenuOpen(!isMobileMenuOpen);
    } else {
      setIsSidebarCollapsed(!isSidebarCollapsed);
    }
  };

  const closeMobileMenu = () => {
    setIsMobileMenuOpen(false);
  };

  // Lock body scroll while the mobile drawer is open
  useEffect(() => {
    if (isMobileMenuOpen) {
      document.body.style.overflow = "hidden";
      return () => {
        document.body.style.overflow = "";
      };
    }
    return undefined;
  }, [isMobileMenuOpen]);

  // If the viewport grows past the mobile breakpoint, drop the drawer state
  useEffect(() => {
    const mq = window.matchMedia("(min-width: 1024px)");
    const onChange = (e) => {
      if (e.matches) setIsMobileMenuOpen(false);
    };
    mq.addEventListener("change", onChange);
    return () => mq.removeEventListener("change", onChange);
  }, []);

  return (
    <div
      className={`flex h-dvh-screen ${colors.bgPrimary} overflow-hidden transition-colors duration-200`}
    >
      {/* Mobile overlay */}
      {isMobileMenuOpen && (
        <div
          className="fixed inset-0 bg-black/50 z-40 lg:hidden backdrop-blur-sm"
          onClick={closeMobileMenu}
        />
      )}

      {/* Sidebar - responsive */}
      <div
        className={`
        fixed lg:static inset-y-0 left-0 z-50
        transform transition-transform duration-300 ease-in-out
        ${isMobileMenuOpen
            ? "translate-x-0"
            : "-translate-x-full lg:translate-x-0"
          }
      `}
      >
        <Sidebar
          isCollapsed={isMobileMenuOpen ? false : isSidebarCollapsed}
          toggleSidebar={toggleSidebar}
          onNavigate={closeMobileMenu}
        />
      </div>

      <div className="flex-1 flex flex-col overflow-hidden w-full relative min-w-0">
        <Header
          toggleSidebar={toggleSidebar}
          sidebarOpen={!isSidebarCollapsed}
          isMobileMenuOpen={isMobileMenuOpen}
        />
        <main className={`flex-1 overflow-auto ${colors.bgPrimary} relative`}>
          {children}
        </main>
      </div>
    </div>
  );
};

export default Layout;
